<script>
import Header from '@/pages/layouts/partials/header.vue'
import Sidebar from '@/pages/layouts/partials/sidebar.vue'
import {Head} from "@inertiajs/vue3";
import Translate from "@/helpers/Translate.js";
import TranslateModal from '@/pages/translation/translate-modal.vue';

export default {
	components: {
		Head,
		Header,
		Sidebar,
		TranslateModal
	},
	props: {
		title: String,
	},
	mounted() {
		Translate.init(this.$page.props.translation_last_updated_at);

		let params = new URLSearchParams(window.location.search);

		['success', 'warning', 'info', 'error', 'danger'].forEach((key) => {
			if (params.has(key)) {
				let level = key === 'error' ? 'danger' : key;
				Helpers.Message.flash(params.get(key), level);
			}
		});
	},
}
</script>

<template>
	<Head :title="title"/>

    <a href="#content" class="skip-to-content btn btn-with-arrow btn-primary" aria-hidden="true">Direct naar hoofdinhoud</a>

	<div id="main-wrapper">
        <Header/>

        <div class="d-flex">
            <Sidebar/>

            <main id="content" class="flex-grow-1 d-flex flex-column">
                <div class="container-fluid py-container top-buttons">
                    <div class="d-flex flex-column flex-sm-row flex-wrap align-items-sm-center">
                        <div class="ps-lg-container">
                            <h1 class="m-0">{{ title }}</h1>
                        </div>

                        <div v-if="$slots.topButtons" class="text-sm-end ms-sm-auto pt-2 pt-sm-0 ps-sm-3">
                            <div class="d-flex justify-content-sm-end align-items-sm-center">
                                <slot name="topButtons"></slot>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container-fluid flex-grow-1 pb-container">
                    <slot/>
                </div>

                <div v-if="$slots.bottomButtons" class="fixed-bottom-bar py-gutter-half bg-white shadow position-sticky bottom-0 left-0 w-100">
                    <div class="bottom-bar-placeholder"></div>
                    <div class="bottom-bar-content d-flex align-items-center">
                        <div class="container-fluid">
                        	<div class="container-fluid">
								<div class="d-flex">
									<slot name="bottomButtons"></slot>
								</div>
	                        </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
	</div>

	<div data-message-container class="toast-container top-0 end-0 p-2 p-lg-4 position-fixed message-wrapper"></div>
	<div data-alert-container></div>

	<TranslateModal/>
	
</template>